import { getEnv } from "app/utils";

let bffApiUrl = getEnv("BFF_API_URL", "/");

if (!bffApiUrl.endsWith("/")) {
  bffApiUrl = `${bffApiUrl}/`;
}

export const ApiUrls = {
  Config: `${bffApiUrl}jsonapi/config`,
  Pools: `${bffApiUrl}jsonapi/pools`,
  Availability: `${bffApiUrl}jsonapi/availability`,
  Encrypt: `${bffApiUrl}jsonapi/encrypt`,
  Obtain3DParameters: `${bffApiUrl}jsonapi/obtain3DParameters`,
  InitTransaction: `${bffApiUrl}jsonapi/initTransaction`,
  Booking: `${bffApiUrl}jsonapi/booking`,
  Logging: `${bffApiUrl}jsonapi/logging`,
  ErrorLogging: `${bffApiUrl}jsonapi/javascriptErrorLogger`,
  Token: `${bffApiUrl}jsonapi/token`,
  PaymentData: `${bffApiUrl}jsonapi/paymentData`,
  PaymentStatus: `${bffApiUrl}jsonapi/paymentStatus`,
  PaymentLogging: `${bffApiUrl}jsonapi/paymentLogging`,
  FqtvValidation: `${bffApiUrl}jsonapi/validateFqtv`,
  ChangeLanguage: `${bffApiUrl}jsonapi/setLang`,
  VoucherValidation: `${bffApiUrl}jsonapi/validateVouchers`
} as const;

export type ApiUrlsTypes = (typeof ApiUrls)[keyof typeof ApiUrls];
